import { getRuntimePublicConfig } from "@/lib/runtime-public-config";

/**
 * Get the base URL for the application
 * This handles both development and production environments.
 * Uses runtime config (no build-time NEXT_PUBLIC_ required).
 */
export function getBaseUrl(): string {
  const config = getRuntimePublicConfig();

  if (process.env.NODE_ENV === "development") {
    return config.NEXT_PUBLIC_APP_URL || "http://localhost:3001";
  }

  return config.NEXT_PUBLIC_APP_URL || "https://needbridge.com";
}

/**
 * Build a full URL for a given path
 */
export function buildUrl(path: string): string {
  const baseUrl = getBaseUrl();
  const cleanPath = path.startsWith("/") ? path : `/${path}`;

  return `${baseUrl}${cleanPath}`;
}

const EMAIL_BASE_URL_DEFAULT = "https://needbridge.com";

/**
 * Get the base URL for email links.
 * Defaults to needbridge.com when NEXT_PUBLIC_APP_URL is not set or is localhost,
 * so emails never contain localhost links (e.g. in misconfigured production).
 */
function getEmailBaseUrl(): string {
  const config = getRuntimePublicConfig();
  const envUrl = config.NEXT_PUBLIC_APP_URL?.trim();

  if (
    envUrl &&
    (envUrl.startsWith("http://") || envUrl.startsWith("https://")) &&
    !/^https?:\/\/localhost(:\d+)?(\/|$)/i.test(envUrl)
  ) {
    return envUrl.replace(/\/$/, "");
  }

  return EMAIL_BASE_URL_DEFAULT;
}

/**
 * Build a full URL for email links
 */
export function buildEmailUrl(path: string): string {
  const baseUrl = getEmailBaseUrl();
  const cleanPath = path.startsWith("/") ? path : `/${path}`;

  return `${baseUrl}${cleanPath}`;
}
